import { SafeSessionStorage } from '#pplx/frontend/browser-storage/sessionStorage.js';
export const SIGNUP_BANNER_DISMISSED_KEY = 'signUpBannerDismissed';
export const resetSignupPopup = () => SafeSessionStorage.setItem(SIGNUP_BANNER_DISMISSED_KEY, 'reset');
//# sourceMappingURL=signupBannerDismissed.js.map